var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocketE(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3966",
    "data-name": "Rectangle 3966",
    width: 24,
    height: 24,
    transform: "translate(17008 -3868)",
    fill: "#02e0fa",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_422",
    "data-name": "Mask Group 422",
    transform: "translate(-17008 3868)",
    clipPath: ""
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(17006.285 -3869.715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4031",
    "data-name": "Path 4031",
    d: "M17.617,8.4a1.43,1.43,0,1,0,1.011.418A1.43,1.43,0,0,0,17.617,8.4Z",
    fill: "#02e0fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4032",
    "data-name": "Path 4032",
    d: "M25.578,2.682a.015.015,0,0,1,0,0,1.093,1.093,0,0,0-.811-.82c-1.6-.389-4.108.026-6.891,1.14a22.166,22.166,0,0,0-7.21,4.565A17.18,17.18,0,0,0,9.083,9.375a7.018,7.018,0,0,0-3.138.5c-3.093,1.362-3.976,4.845-4.212,6.275A1.339,1.339,0,0,0,3.19,17.708H3.2l3.445-.376c0,.044.009.084.013.121a1.841,1.841,0,0,0,.53,1.11l1.682,1.683a1.836,1.836,0,0,0,1.109.531l.115.012-.375,3.442v.007A1.33,1.33,0,0,0,11.258,25.7c1.438-.232,4.92-1.1,6.278-4.214a7.081,7.081,0,0,0,.506-3.125,16.863,16.863,0,0,0,1.819-1.583,22,22,0,0,0,4.57-7.153c1.109-2.751,1.525-5.282,1.146-6.94ZM19.842,12.05a3.123,3.123,0,1,1,.932-2.225,3.148,3.148,0,0,1-.932,2.225Z",
    fill: "#02e0fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4033",
    "data-name": "Path 4033",
    d: "M8.675,20.7a.857.857,0,0,0-.589.143c-.342.234-.686.466-1.033.691a.8.8,0,0,1-1.125-1.071l.651-1.125a.857.857,0,0,0-.812-1.334,3.282,3.282,0,0,0-1.909.935c-.2.2-.792.793-1.113,3.067a19.176,19.176,0,0,0-.173,1.97.857.857,0,0,0,.857.879H3.45a19.279,19.279,0,0,0,1.971-.171c2.275-.322,2.872-.918,3.068-1.115a3.24,3.24,0,0,0,.932-1.915.857.857,0,0,0-.746-.955Z",
    fill: "#02e0fa"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketE);
export default __webpack_public_path__ + "static/media/rocket_e.99d72914d05dabaaa93fbe1d816ef0be.svg";
export { ForwardRef as ReactComponent };